import { useQueryClient, type QueryKey } from '@tanstack/react-query'
import { useServiceEventStream, type ChainEventMessage } from '@/lib/eventStream'

// While the service event stream is down, chain reads go stale after this long
// and refetch on focus or remount, so the console still catches up.
export const STREAM_DOWN_STALE_TIME_MS = 30_000

// staleTime for a stream-invalidated chain read: never stale while the stream
// is connected (every relevant event invalidates it), coarse otherwise.
export function streamStaleTime(connected: boolean): number {
    return connected ? Infinity : STREAM_DOWN_STALE_TIME_MS
}

// Invalidates `queryKeys` whenever a stream message satisfies `matches`, and on
// a stream `reset`. Stream messages carry indexed args only, so hooks refetch
// with eth_call rather than patching the cache from event data.
export function useStreamInvalidation(
    chainId: number,
    enabled: boolean,
    matches: (message: ChainEventMessage) => boolean,
    queryKeys: readonly QueryKey[],
): { connected: boolean } {
    const queryClient = useQueryClient()
    const invalidate = () => {
        for (const queryKey of queryKeys) queryClient.invalidateQueries({ queryKey })
    }
    return useServiceEventStream(
        chainId,
        (message) => {
            if (matches(message)) invalidate()
        },
        invalidate,
        enabled,
    )
}
